import {
  isSchemaSection,
  isSchemaSimpleMultiValue,
  isSchemaTableMultiValue,
  isSchemaTuple,
  SchemaItem,
  SchemaSection,
} from '@rossum/api-client/schemas';
import { LegacyThresholdsTableRowModel } from './types';

/**
 * Extracts rows for legacy automation thresholds table from schema content.
 * Only includes datapoints with valueSource 'captured' or 'unset' (null/undefined).
 * Recursively processes schema sections, tuples, and multivalues.
 */
export const getLegacyThresholdsRows = ({
  schemaContent,
  defaultScoreThreshold,
}: {
  schemaContent: SchemaSection[];
  defaultScoreThreshold: number;
}): LegacyThresholdsTableRowModel[] => {
  const result: LegacyThresholdsTableRowModel[] = [];

  const processItem = (item: SchemaSection | SchemaItem): void => {
    if (isSchemaSection(item)) {
      item.children.forEach(processItem);
      return;
    }

    if (isSchemaTableMultiValue(item)) {
      item.children.children.forEach(processItem);
      return;
    }

    if (isSchemaSimpleMultiValue(item)) {
      if (item.children.type !== 'button') {
        const uiConfigType = item.children.uiConfiguration?.type;
        const shouldInclude =
          uiConfigType === 'captured' ||
          uiConfigType === null ||
          uiConfigType === undefined;

        if (shouldInclude) {
          result.push({
            schemaId: item.children.id,
            datapointLabel: item.children.label,
            currentThreshold:
              item.children.scoreThreshold ?? defaultScoreThreshold,
          });
        }
      }
      return;
    }

    if (isSchemaTuple(item)) {
      item.children.forEach(processItem);
      return;
    }

    if (item.type !== 'button') {
      const uiConfigType = item.uiConfiguration?.type;
      const shouldInclude =
        uiConfigType === 'captured' ||
        uiConfigType === null ||
        uiConfigType === undefined;

      if (shouldInclude) {
        result.push({
          schemaId: item.id,
          datapointLabel: item.label,
          currentThreshold: item.scoreThreshold ?? defaultScoreThreshold,
        });
      }
    }
  };

  schemaContent.forEach(processItem);
  return result;
};
